import { useEffect, useRef } from "react";

export default function usePrevious<T>(value: T) {
    const ref = useRef<T>();
    useEffect(() => {
      ref.current = value && JSON.parse(JSON.stringify(value));
    }, [value]);
    return ref.current;
  }